<template>
  <div class="bank">
    <div class="accordion" id="kt_accordion_1">
      <div class="accordion-item border-left-0 border-right-0 border-bottom-0">
        <h2 class="accordion-header" id="kt_accordion_1_header_1">
          <button class="accordion-button fs-6 fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#kt_accordion_1_body_1" aria-expanded="false" aria-controls="kt_accordion_1_body_1">
            Банковские реквизиты
          </button>
        </h2>
        <div id="kt_accordion_1_body_1" class="accordion-collapse collapse" aria-labelledby="kt_accordion_1_header_1" data-bs-parent="#kt_accordion_1">
          <div class="accordion-body p-5">
            <input-field
                v-model="bank.iik"
                @focusout="validateIBAN"
                id="bank.iik"
                name="bank.iik"
                :has-error="!valid"
                placeholder="ИИК (IBAN)"
                type="text"
                mb="5"
            />
            <input-field
                v-model="bank.bik"
                id="bank.bik"
                name="bank.bik"
                placeholder="БИК"
                type="text"
                mb="5"
            />
            <input-field
                v-model="bank.name"
                id="bank.name"
                name="bank.name"
                placeholder="Банк"
                type="text"
                mb="5"
            />
            <input-field
                v-model="bank.kbe"
                id="bank.kbe"
                name="bank.kbe"
                placeholder="КБЕ"
                type="text"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputField from '@/components/Fields/InputField'

export default {
  name: 'CustomerBank',
  components: { InputField },
  props: {
    bank: null,
    isPerson: {
      type: Boolean,
      default: false
    },
    isResident: {
      type: Boolean,
      default: true
    },
    module: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      valid: true,
    }
  },
  methods: {
    validateIBAN() {
      this.valid = this.module.Validator.isValidIBANNumber(this.bank.iik)
    }
  },
  watch: {
    'bank.iik': {
      deep: true,
      handler(val) {
        if (val) {
          let ibanKZ   = val.length > 1 ? val.slice(0, 2).toLowerCase() === 'kz' : false
          let ibanNum  = val.length > 3 ? /^\d+$/.test(val.slice(2, 4)) : false
          let ibanCode = val.length > 6 ? val.slice(4, 7) : false
          if (ibanKZ && ibanNum && ibanCode) {
            const data = this.module.Client.bikAndNameByCode(ibanCode)
            if (data && data.hasOwnProperty('bik')) {
              this.bank.name = data.name
              this.bank.bik  = data.bik
              this.bank.kbe  = this.isPerson ? (this.isResident ? '19' : '29') : (this.isResident ? '17' : '27')
            } else {
              this.bank.name = null
              this.bank.bik  = null
            }
          } else {
            this.bank.name = null
            this.bank.bik  = null
          }
        }
        if (!val && !this.bank.kbe) {
          this.bank.name = null
          this.bank.bik  = null
        }
      }
    }
  }
}
</script>

<style scoped>

</style>